<template>
    <div class="title-bar">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "TitleBar"
};
</script>

<style lang="scss" scoped>
.title-bar {
    font-size: 16px;
    padding: 16px 13px 8px 13px;
    background: #fff;
    font-weight: bold;
    color: #41475e;
}
</style>
